import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

type Entity = models.DocumentacionDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas : Column[] = [
    {title: "Fecha de creación", cell: x => ({data: kea.toDate(x.FechaCreacion) })},
    {title: "Cliente", cell: x => ({data: x.NombreClienteOrigen })},
    {title: "Suc. origen", cell: x => ({data: x.NombreSucursalOrigen })},
    {title: "Origen", cell: x => ({data: x.DireccionOrigenDTO.Descripcion })},
    {title: "Cant. guias", cell: x => ({data: x.CantGuias })},
    
];

export interface BotonesListaDeps<T> {
    onVer: (x: T) => void;
    onImprimir: (x: T) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesListaDeps<Entity>) : Column[] {
    const botones = kea.columnaBotones<Entity>([{
         onClick: x => deps.onVer(x),
         tooltip: "Ver",
         iconClass: fa("eye")
    }]);
    
    return [botones, ... columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/documentacion/list/columns.tsx